export type CandidateEditNavigationState = {
  startAiRefreshOnLoad?: boolean;
  openConsentForm?: boolean;
};

export const candidateEditAiRefreshNavigationState: CandidateEditNavigationState = {
  startAiRefreshOnLoad: true,
};

export const shouldStartCandidateAiRefreshOnLoad = (state: unknown) =>
  Boolean((state as CandidateEditNavigationState | null)?.startAiRefreshOnLoad);

export const candidateEditOpenConsentsNavigationState: CandidateEditNavigationState = {
  openConsentForm: true,
};

export const shouldOpenCandidateConsentForm = (state: unknown) =>
  Boolean((state as CandidateEditNavigationState | null)?.openConsentForm);
